<template>
    <div>
        <el-breadcrumb separator="/" class="page-breadcrumb">
            <el-breadcrumb-item>
                交易活动设置
            </el-breadcrumb-item>
        </el-breadcrumb>
        <el-card shadow="never" class="page-content">
            <el-row>
                <el-col :span="13">
                    <el-form ref="form" :model="config" :rules="rules" label-width="150px">
                        <el-form-item label="活动参与交易对" prop="pair">
                            <el-input v-model="config.pair"></el-input>
                        </el-form-item>
                        <el-form-item label="活动时间" prop="time">
                            <el-date-picker v-model="config.time" type="datetimerange" range-separator="至"
                                            start-placeholder="活动开始时间" end-placeholder="活动结束时间"></el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitConfig()">确认提交</el-button>
                            <el-button type="info" @click="reset">恢复初始值</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-card>
        <el-card shadow="never" class="page-content">
            <el-button type="primary" @click="clearCache()">清除交易统计数据缓存</el-button>
        </el-card>
    </div>
</template>

<script>
    import '../store';
    import {mapActions, mapState} from 'vuex';

    export default {
        name: "projectActivity",
        data() {
            return {
                config: {
                    pair: '',
                    time: [],
                },
                rules: {
                    pair: [{required: true, message: '请输入活动参与币种', trigger: 'blur'}],
                    time: [{required: true, message: '请输入活动时间', trigger: 'blur'}]
                },
            }
        },

        computed: {
            ...mapState('tradeStatistic', ['configInfo'])
        },

        methods: {
            ...mapActions('tradeStatistic', ['getConfigInfo', 'buildConfig', 'clearStatistic']),
            submitConfig() {
                console.log("---" + this.config.time)
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        let data = {
                            pair: this.config.pair,
                            startTime: this.config.time[0],
                            endTime: this.config.time[1]
                        };

                        this.buildConfig(data).then(() => {
                            this.$message({type: 'success', message: '提交配置信息成功'});
                            this.clearStatistic();
                            this.getConfigInfo().then(() => {
                                this.reset();
                            })
                        })
                    }
                })
            },

            reset() {
                this.config.pair = this.configInfo.pair;
                let start = this.configInfo.start;
                let end = this.configInfo.end;
                this.config.time = [new Date(start.year,start.monthValue - 1,start.dayOfMonth,start.hour,start.minute,start.second),new Date(end.year,end.monthValue - 1,end.dayOfMonth,end.hour,end.minute,end.second)]
            },

            clearCache() {
                this.clearStatistic().then(() => {
                    this.$message({type: 'success', message: '清除缓存成功'});
                })
            }
        },

        created() {
            this.getConfigInfo().then(() => {
                this.reset()
            });
        }
    }
</script>

<style scoped>

</style>